import React, { useContext } from "react";
import { FormContext } from "./Form";
import { Informative } from "../../Inputs/General/Index";
import { InvoiceNumberArea } from "./Styles";

export default function Invoice({ value, className = "" }) {
  /**
   * @type {{
   *    document:import("types/typedef/documents").DocumentI
   * }}
   */
  const { document } = useContext(FormContext);

  return (
    <>
      {className !== "" ? (
        <div>
          <Informative
            readonly={true}
            label="Factura"
            value={!value ? document.documents.invoice.documentNumber : value}
          />
        </div>
      ) : (
        <InvoiceNumberArea>
          <Informative
            readonly={true}
            label="Factura"
            value={!value ? document.documents.invoice.documentNumber : value}
          />
        </InvoiceNumberArea>
      )}
    </>
  );
}
